import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, DateTime, TextArea, RequiredValidator, EventTriggers } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';
import { dateTimeToString } from '../../Services/helpers';
import { eventTriggers } from '../../Data/Misc';

const Skip = ({job, onClose, then}) => {
    return <Modal title="Skip job" isOpen={!!job} setIsOpen={onClose}>
        {job && <Inner job={job} then={then} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {skipJob} = useCustomer(job?.customerId);

    return <Form data={{skippedOn: dateTimeToString(new Date(), 'T')}}
            onSubmit={d => skipJob(job.id, d)}
            afterSubmit={then}
            closeModalOnSubmit
        >
        <DateTime name="skippedOn" label="Skipped at" validators={[RequiredValidator]} defaultNow />
        <TextArea name="notes" label="Notes" />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit={{label: 'Skip'}} cancel />
    </Form>
}

export default Skip;
